import React from "react";
import "./AssessmentCalendar.scss";
interface AssessmentCalendarProps {
  days: number;
}

export const AssessmentCalendarDays: React.FC<AssessmentCalendarProps> = ({ days }) => {
  return (
    <div className="assessment-calendar">
      <div className="assessment-calendar-title">{days}</div>
    </div>
  );
};
